<!-- 沥青路面预防性养护初选库-->
<template>
  <d2-container>
    <div v-show="!showTabFom">
      <el-row style="margin-bottom: 20px">
        <el-col :span="4">
          <popover-form popoverWidth="680" :formConfig="advSearch" v-model="searchForm" @onSubmit="searchTable"></popover-form>
        </el-col>
        <el-col :span="20">
            <div class="text-align_right">
                <el-button type="primary" @click="addRow">新增</el-button>
            </div>
        </el-col>
      </el-row>
      <div>
        <dynamic-table
          :tableSet="tableSet"
          :tableData="tableData"
          :pageIndex="pageIndex"
          :pageShow="false"
          :pageShowX = "true"
          @goPageIndex="goPageIndex"
          :pageCount="pageCount"
          @rowClick="rowClick($event)"
        ></dynamic-table>
      </div>
    </div>
    <div v-show="showTabFom">
      <div>
        <div>
          <div class="text-align_right">
              <el-button-group>
                <el-button type="primary" v-if="(operationType==1||operationType==2)" @click="dataSubmit" >保存</el-button>
                <el-button type="primary" @click="close">返回</el-button>
              </el-button-group>
          </div>
          <divider title="沥青路面预防性养护初选库明细" />
          <dynamic-form ref="form" :formConfig="formConfig" :disabled="!(operationType==1||operationType==2)" v-model="form"></dynamic-form>
        </div>
      </div>
    </div>
    <template slot="footer" v-if="showTabFom">
      <billing-info :billingInfo="form"></billing-info>
    </template>
  </d2-container>
</template>
<script>
export default {
  name: "cxPitchmeasures",
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    return {
      initializeForm:{},
      showTabFom: false, //表格表单转换状态
      operationType: 1, //主表操作状态

      searchForm: {
        measure :'',/// 适用养护措施
        highwayLevel :'',/// 适用公路等级
      },
      advSearch: {
        list: [
          {
            "type": "select",
            "icon": "icon-select",
            "options": {
              "defaultValue": "","multiple": false,"disabled": false,"clearable": false,"placeholder": "请选择","required": false,"showLabel": false,"width": "250px","options": [],"remote": true,"remoteType": "option",
              "remoteOption": "option_1583391431329","filterable": true,"remoteOptions": [],"props": {"value": "measure","label": "measure"},"remoteFunc": this.getMeasure,"customClass": "","labelWidth": 100,"isLabelWidth": false,"hidden": false,"dataBind": true,"remoteSearch":true,
            },
            "name": "适用养护措施",
            "key": "适用养护措施",
            "model": "measure",
            "rules": [{required: false,message: "必须填写"}]
          },
          {
            "type": "select",
            "icon": "icon-select",
            "options": {
              "defaultValue": "","multiple": false,"disabled": false,"clearable": false,"placeholder": "请选择","required": false,"showLabel": false,"width": "250px","options": [],"remote": true,"remoteType": "option",
              "remoteOption": "option_1583391431329","filterable": true,"remoteOptions": [],"props": {"value": "name","label": "name"},"remoteFunc": this.getDiction,"customClass": "","labelWidth": 100,"isLabelWidth": false,"hidden": false,"dataBind": true,"remoteSearch":true,
            },
            "name": "适用公路等级",
            "key": "公路等级",
            "model": "highwayLevel",
            "rules": [{required: false,message: "必须填写"}]
          }
        ],
        config: {
          labelWidth: 100,
          labelPosition: "right",
          size: "medium",
          customClass: ""
        }
      },
      tableSet: {
        tableColumn: [
          {
            label: "适用养护措施",
            prop: "measure"
          },{
            label: "适用公路等级",
            prop: "highwayLevel"
          },{
            label: "AADT",
            prop: "aadt"
          },{
            label: "龟裂-轻",
            prop: "mildCracking"
          },{
            label: "龟裂-中",
            prop: "moderateCrack"
          },{
            label: "龟裂-重",
            prop: "severeCrack"
          },{
            label: "块裂-轻",
            prop: "mildChipped"
          },{
            label: "块裂-重",
            prop: "severeChipped"
          },{
            label: "裂缝-轻",
            prop: "mildCrack"
          },{
            label: "裂缝-重",
            prop: "severeCracks"
          },{
            label: "坑槽-轻",
            prop: "mildPitSlot"
          },{
            label: "坑槽-重",
            prop: "severePitSlot"
          },{
            label: "松散-轻",
            prop: "mildLoose"
          },{
            label: "松散-重",
            prop: "heavyLoose"
          },{
            label: "沉陷-轻",
            prop: "mildSubsidence"
          },{
            label: "沉陷-重",
            prop: "heavySubsidence"
          },{
            label: "波浪拥包",
            prop: "upheaval"
          },{
            label: "车辙-轻",
            prop: "mildRut"
          },{
            label: "车辙-重",
            prop: "severeRutting"
          },{
            label: "泛油",
            prop: "bleeding"
          },{
            label: "修补",
            prop: "mending"
          },{
            label: "备注",
            prop: "remark"
          }
        ],
        tableColBtn: [
          {
            show: true,
            size: "mini",
            type: "primary",
            plain: true,
            round: false,
            circle: false,
            loading: false,
            disabled: false,
            icon: "el-icon-view",
            title: "查看",
            name: "查看",
            click: this.rowClick
          },
          {
            show: true,
            size: "mini",
            type: "primary",
            plain: true,
            round: false,
            circle: false,
            loading: false,
            disabled: false,
            icon: "el-icon-edit",
            title: "编辑",
            name: "编辑",
            click: this.edit
          },
          {
          show: true,
          size:'mini',
          type:'danger',
          plain: true,
          round: false,
          circle: false,
          loading: false,
          disabled: false,
          icon:'el-icon-delete',
          title:'删除',
          name:'删除',
          click: this.del
        }
        ]
      },
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      pageCount: 0,
      form: {
        rowCode :0,/// 主键int
        mildCracking :'0',/// 龟裂-轻
        moderateCrack :'0',/// 龟裂-中
        severeCrack :'0',/// 龟裂-重
        mildChipped :'0',/// 块裂-轻
        severeChipped :'0',/// 块裂-重
        mildCrack :'0',/// 裂缝-轻（含纵缝、横缝）
        severeCracks :'0',/// 裂缝-重
        mildPitSlot :'0',/// 坑槽-轻
        severePitSlot :'0',/// 坑槽-重
        mildLoose :'0',/// 松散-轻
        heavyLoose :'0',/// 松散-重
        mildSubsidence :'0',/// 沉陷-轻
        heavySubsidence :'0',/// 沉陷-重
        upheaval :'0',/// 波浪拥包
        mildRut :'0',/// 车辙-轻
        severeRutting :'0',/// 车辙-重
        bleeding :'0',/// 泛油
        mending :'0',/// 修补
        measure :'',/// 适用养护措施
        highwayLevel :[],/// 适用公路等级
        aadt :'',/// AADT
        remark :'',/// 备注
        createUser :'',
        createUserName :'',
        createTime :'',
        updateUser :'',
        updateUserName :'',
        updateTime :'',
        status :'',
        r1 :'',
        r2 :'',
        r3 :'',
        r4 :'',
        r5 :'',
      },
      formConfig: {
        list: [
          {
            "type": "select",
            "icon": "icon-select",
            "options": {
              "defaultValue": "","multiple": false,"disabled": false,"clearable": false,"placeholder": "请选择","required": true,"showLabel": false,"width": "250px","options": [],"remote": true,"remoteType": "option",
              "remoteOption": "option_1583391431329","filterable": true,"remoteOptions": [],"props": {"value": "measure","label": "measure"},"remoteFunc": this.getMeasure,"customClass": "","labelWidth": 100,"isLabelWidth": false,"hidden": false,"dataBind": true,"remoteSearch":true,
            },
            "name": "适用养护措施",
            "key": "适用养护措施",
            "model": "measure",
            "rules": [{required: true,message: "必须填写"}]
          },
          {
            "type": "select",
            "icon": "icon-select",
            "options": {
              "defaultValue": "","multiple": true,"disabled": false,"clearable": false,"placeholder": "请选择","required": true,"showLabel": false,"width": "250px","options": [],"remote": true,"remoteType": "option",
              "remoteOption": "option_1583391431329","filterable": true,"remoteOptions": [],"props": {"value": "name","label": "name"},"remoteFunc": this.getDiction,"customClass": "","labelWidth": 100,"isLabelWidth": false,"hidden": false,"dataBind": true,"remoteSearch":true,
            },
            "name": "适用公路等级",
            "key": "公路等级",
            "model": "highwayLevel",
            "rules": [{required: true,message: "必须填写"}]
          },
          {
            type: "input",
            icon: "icon-input",
            options: {
              width: "100%",defaultValue: "",required: false,dataType: "string",pattern: "",placeholder: "",customClass: "",disabled: false,labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,showPassword: false,remoteFunc: "func_1573044806373"
            },
            name: "AADT",
            novalid: {},
            key: "aadt",
            model: "aadt",
            rules: [{type: "string",message: "格式不正确"}]
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "龟裂-轻",
            novalid: {},
            key: "mildCracking",
            model: "mildCracking",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "龟裂-中",
            novalid: {},
            key: "moderateCrack",
            model: "moderateCrack",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "龟裂-重",
            novalid: {},
            key: "severeCrack",
            model: "severeCrack",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "块裂-轻",
            novalid: {},
            key: "mildChipped",
            model: "mildChipped",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "块裂-重",
            novalid: {},
            key: "severeChipped",
            model: "severeChipped",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "裂缝-轻",
            novalid: {},
            key: "mildCrack",
            model: "mildCrack",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "裂缝-重",
            novalid: {},
            key: "severeCracks",
            model: "severeCracks",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "坑槽-轻",
            novalid: {},
            key: "mildPitSlot",
            model: "mildPitSlot",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "坑槽-重",
            novalid: {},
            key: "severePitSlot",
            model: "severePitSlot",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "松散-轻",
            novalid: {},
            key: "mildLoose",
            model: "mildLoose",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "松散-重",
            novalid: {},
            key: "heavyLoose",
            model: "heavyLoose",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "沉陷-轻",
            novalid: {},
            key: "mildSubsidence",
            model: "mildSubsidence",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "沉陷-重",
            novalid: {},
            key: "heavySubsidence",
            model: "heavySubsidence",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "波浪拥包",
            novalid: {},
            key: "upheaval",
            model: "upheaval",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "车辙-轻",
            novalid: {},
            key: "mildRut",
            model: "mildRut",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "车辙-重",
            novalid: {},
            key: "severeRutting",
            model: "severeRutting",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "泛油",
            novalid: {},
            key: "bleeding",
            model: "bleeding",
            rules: []
          },
          {
            type: "radio",
            icon: "icon-radio-active",
            options: {inline: true,defaultValue: "0",showLabel: true,options: [{value: "0",label: "否"},{value: "1",label: "是"}],required: false,
            width: "",remote: false,remoteOptions: [],props: {value: "value",label: "label"},remoteFunc: "func_1573044947832",customClass: "",
            labelWidth: 100,isLabelWidth: false,hidden: false,dataBind: true,disabled: false
            },
            name: "修补",
            novalid: {},
            key: "mending",
            model: "mending",
            rules: []
          },
          {
            "type": "textarea",
            "icon": "icon-diy-com-textarea",
            "options": {
              "width": "500px","defaultValue": "","required": false,"disabled": false,"pattern": "","placeholder": "","customClass": "",
              "labelWidth": 100,"isLabelWidth": false,"hidden": false,"dataBind": true,"remoteFunc": "func_1577068006527","remoteOption": "option_1577068006527"
            },
            "name": "备注",
            "key": "1577068006527",
            "model": "remark",
            "rules": []
          }
        ],
        config: {
          labelWidth: 100,
          labelPosition: "right",
          size: "medium",
          customClass: ""
        }
      },
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
  },
  //方法集合
  methods: {
    /********字典获取 ******/
    getDiction(target, targets) {
        let name = target.form.key;
        this.$http.post(this.$url.getDict, { search: name }).then(res => {
            let { data } = res;
            target.setList(data);
        });
    },
    getMeasure(target, targets){
      this.$http.post(this.$url.routeDecision.getpmmeasurefs, { pageSize: 9999999,pageIndex:1 }).then(res => {
          let { data } = res;
          target.setList(data);
      });
    },
    setHighwayLevel(row){
      if (row.highwayLevel) {
        if(row.highwayLevel.indexOf(',')>=0){this.form.highwayLevel = row.highwayLevel.split(",")
        }else if(row.highwayLevel.indexOf('，')>=0){this.form.highwayLevel = row.highwayLevel.split("，")
        }else{this.form.highwayLevel = [row.highwayLevel];}
      }else{ this.form.highwayLevel = []; }
    },
    /*******获取表格数据*****/
    getTableData() {//获取表格数据
        let that = this;
        this.$http.postHandle('',this.$url.routeDecision.getpitchmeasures, { ...that.searchForm, pageIndex:this.pageIndex, pageSize:this.pageSize }).then(res => {
            this.tableData = res.data;
            this.pageCount = res.pageCount;
        });
    },
    addRow() {//新增
      this.showTabFom = true;
      this.operationType = 1;
      this.resetForm("form");
    },
    searchTable(){//查询
      this.pageIndex = 1;
      this.pageSize = pageSize;
      this.getTableData();
    },
    goPageIndex(pageIndex,pageSize) {//分页
      this.pageIndex = pageIndex;
      this.pageSize = pageSize
      this.getTableData();
    },
    rowClick(row) {//查看
        this.operationType = 3;
        this.form = this.$formSetForm(this.form,row);
        this.setHighwayLevel(row);
        this.showTabFom = true;
    },
    edit(row, index) {//编辑
        this.operationType = 2;
        this.form = this.$formSetForm(this.form,row);
        this.setHighwayLevel(row);
        this.showTabFom = true;
    },
    del(row, index) {//删除
      let form = row;
      this.$msgDel(this.$url.routeDecision.operationpitchmeasure, { pitchMeasure: form, operationType: 8 }).then(res => {
        if((this.tableData.length<=1)&&(this.pageIndex>1)){
          this.pageIndex=this.pageIndex-1;
        }
        this.getTableData();
      });
    },
    dataSubmit() {//保存
        this.$refs.form.submit().then(res => {
            let form = this.$formSetForm(this.form, this.form);
            form.highwayLevel = this.form.highwayLevel.join(",");
            this.$http.postHandle("保存", this.$url.routeDecision.operationpitchmeasure, { pitchMeasure: form, operationType: this.operationType }).then(res => {
                this.showTabFom = false;
                this.getTableData();
            });
        });
    },
    close() {//返回
      this.$closePage(this.operationType).then(() => {
        this.showTabFom = false;
        this.getTableData();
      });
    },
    resetForm(formName) {//重置
      let that = this;
      this.form = this.$formSetForm(this.initializeForm , this.initializeForm)
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getTableData();
    this.initializeForm = this.$formSetForm(this.form , this.form);
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {}
};
</script>
<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/views/decision/PavementMaintenancePlanningCustomization/PreventiveMaintenanceDic/cxPitchmeasures.vue"
}
</vue-filename-injector>
